// start coding
console.log('Javascript found');

/* Variables */
const body = document.body;

function addSmoothScrolling() {
	const links = document.querySelectorAll('a[href^="#"]');
	for (const link of links) {
		link.addEventListener('click', smoothScroll);

		if (link.classList.contains("anchor-link")) {
			link.addEventListener('click', copyUrlToClipboard)
		}
	}
}

function smoothScroll(event) {
	event.preventDefault();
	const href = this.getAttribute('href');
	const url = window.location.href.replace(/#[^#]*$/, '') + href;
	window.history.replaceState(null, null, url);

	if (href === '#') {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	} else {
		// Otherwise, scroll to the target element
		const target = document.querySelector(href);
		const offset = 80; // Change this value to adjust the space between the top of the window and the target element
		const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({
			top,
			behavior: 'smooth'
		});
	}
}

function markInternalLinks() {
	const currentHostname = window.location.hostname;
	const links = document.querySelectorAll('.entry-content > .container a:not(.post-navigation, a.download__item, .anchor-link, .btn)');

	for (let i = 0; i < links.length; i++) {
		const link = links[i];
		const href = link.getAttribute('href');


		if (href && href.startsWith('/') && !href.startsWith('//')) {
			// Link points to a relative URL
			link.classList.add('internal-link');
		} else if (href && href.startsWith('http')) {
			const url = new URL(href);
			if (url.hostname === currentHostname) {
				// Link points to an internal page without a hash
				link.classList.add('internal-link');
			}
		} else if (href && href.startsWith('#')) {
			// Link points to a hash on the same page
			link.classList.add('internal-link');
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
  addSmoothScrolling();
  markInternalLinks();

  const slideshows = document.querySelectorAll('.slideshow');

  for (const el of slideshows) {
    const slideshow = el;
    const slider = slideshow.querySelector('.slideshow__slider');
    watchslideshow(el, false);
  }
});


// MODAL
function openModal(slideshow) {
	body.classList.add('no-scroll');
	const scrollLeft = slideshow.querySelector(".slider__inner").scrollLeft;

	const images = slideshow.querySelectorAll('img');

	const modal = document.createElement('div');
	modal.className = "modal";

	const backgroundOverlay = document.createElement('div');
	backgroundOverlay.className = "background-overlay";

	const slideshowClone = slideshow.cloneNode(true)
	slideshowClone.id = "";
	slideshowClone.dataset.ref = `${slideshow.id}`;

	const closeButton = slideshowClone.querySelector(".btn-modal-close");

	[closeButton, backgroundOverlay].forEach(el => {
		el.addEventListener('click', () => {
			body.classList.remove('no-scroll');
			modal.remove();
		})
	})

	slideshowClone.querySelectorAll("img").forEach(img => {
		img.setAttribute("sizes", "100vw");
	})

	slideshowClone.querySelector('.slider__zoom').remove();

	watchslideshow(slideshowClone, true);
	modal.append(slideshowClone, backgroundOverlay)
	body.append(modal);
	modal.classList.add('show-modal');

	slideshowClone.querySelector(".slider__inner").scrollTo({
		top: 0,
		left: slideshowClone.querySelectorAll(`img`)[slideshow.dataset.index].offsetLeft,
		behavior: "instant",
	});
}

function showImage(index, slideshow, isScroll = false) {
	if(!isScroll){
		slideshow.querySelector(`.slider__inner`).scrollTo({
			top: 0,
			left: slideshow.querySelectorAll(`img`)[index].offsetLeft,
			behavior: "smooth",
		});
	}

	if (slideshow.dataset.ref) {
		const id = slideshow.dataset.ref;

		document.getElementById(id).querySelector(".slider__inner").scrollTo({
			top: 0,
			left: document.getElementById(id).querySelectorAll(`img`)[index].offsetLeft,
			behavior: "smooth",
		});
	}
	updatePagination(slideshow, index);
}

function watchslideshow(slideshow, ismodal) {
	let sourceslideshow;

	const pagination = slideshow.querySelector('.pagination');

	pagination.querySelectorAll('.pagination__indicator').forEach((el, index) => {
		el.addEventListener('click', () => {

			slideshow.dataset.index = index;
			showImage(index, slideshow);

			if (ismodal) {
				showImage(index, sourceslideshow, true)
			}
		})
	})


	const controls = slideshow.querySelector('.slider__controls');
	const controlsNext = controls.querySelector('.controls__next');
	const controlsPrev = controls.querySelector('.controls__prev');

	controlsNext.addEventListener('click', () => {
		if ((slideshow.querySelectorAll('img').length - 1) == slideshow.dataset.index) { return; }

		const index = parseInt(slideshow.dataset.index) + 1;
		slideshow.dataset.index = index;
		showImage(index, slideshow);
	})

	controlsPrev.addEventListener('click', () => {
		if (0 == slideshow.dataset.index) { return; }
		const index = parseInt(slideshow.dataset.index) - 1;
		slideshow.dataset.index = index;
		showImage(index, slideshow);
	})

	window.addEventListener("keydown", function closemodal(e) {
		if (e.keyCode === 27) {
			body.classList.remove('no-scroll');
			modal.remove();
			this.window.removeEventListener("keydown", closemodal)
		} else if (e.keyCode == 39) {
			if ((slideshow.querySelectorAll('img').length - 1) == slideshow.dataset.index) { return; }
			const index = parseInt(slideshow.dataset.index) + 1;
			slideshow.dataset.index = index;
			showImage(index, slideshow)
		} else if (e.keyCode == 37) {
			if (0 == slideshow.dataset.index) { return; }
			const index = parseInt(slideshow.dataset.index) - 1;
			slideshow.dataset.index = index;
			showImage(index, slideshow)
		}
	})

	const observer = new IntersectionObserver(callback, { threshold: 0.1 });

	const images = slideshow.querySelectorAll("img");
	images.forEach(image => {
		observer.observe(image);
	});

	function callback(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const activeImageIndex = Array.from(images).indexOf(entry.target);
				showImage(activeImageIndex, slideshow, true)
			}
		});
	}

	if (ismodal) { return; }


	const slider = slideshow.querySelector('.slideshow__slider');
	const zoomButton = slideshow.querySelector('.slider__zoom');

	let sliderCenter = 0;
	slider.addEventListener('click', (e) => {
		if (e.target.nodeName === "BUTTON") {
			openModal(slideshow);
		} else {
			let index;
			let mouse = { x: e.offsetX, y: e.offsetY };
	
			if (mouse.x < sliderCenter) {
				if (0 == slideshow.dataset.index) { return; }
				index = parseInt(slideshow.dataset.index) - 1;
			} else if (mouse.x > sliderCenter) {
				if ((slideshow.querySelectorAll('img').length - 1) == slideshow.dataset.index) { return; }
				index = parseInt(slideshow.dataset.index) + 1;
			}
	
			slideshow.dataset.index = index;
			showImage(index, slideshow)
		}
	})

	slider.addEventListener('mousemove', (e) => {
		// Get Mouse Position 
		sliderCenter = slider.clientWidth/2;
		const mouseX = e.offsetX;
		const mouseY = e.offsetY;

		let mouse = { x: mouseX, y: mouseY };

		if (mouse.x < sliderCenter && slideshow.dataset.index != 0) {
			slider.dataset.direction = "left";
		} else if (mouse.x > sliderCenter && slideshow.dataset.index != slideshow.querySelectorAll("img").length -1) {
			slider.dataset.direction = "right";
		} else {
			delete slider.dataset.direction;
		}
	}, true);

	slider.addEventListener('mouseleave', (e) => {
		delete slider.dataset.direction;
	})
}

function updatePagination(slideshow, index) {
	const pagination = slideshow.querySelector('.pagination');
	pagination.querySelector(`.pagination__indicator.active`).classList.remove('active');
	pagination.querySelectorAll(`.pagination__indicator`)[index].classList.add('active');
	slideshow.dataset.index = index;

	if (index == 0) {
		slideshow.querySelector(".controls__prev").style.display = "none";
	} else {
		slideshow.querySelector(".controls__prev").style.display = "block";
	}

	if (index == (slideshow.querySelectorAll("img").length - 1)) {
		slideshow.querySelector(".controls__next").style.display = "none";
	} else {
		slideshow.querySelector(".controls__next").style.display = "block";
	}
}
